import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { UserOutlined, AimOutlined, TrophyOutlined, HeartOutlined } from '@ant-design/icons';
import styles from './About.module.scss';

const cx = classNames.bind(styles);

function About() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Kích hoạt animation sau khi component mount
        setIsVisible(true);

        // Kích hoạt animation khi tab được click
        const animateOnTabClick = () => {
            setIsVisible(false);
            setTimeout(() => setIsVisible(true), 50);
        };

        // Theo dõi khi tab được click lại
        const tabElement = document.querySelector('[href="/gioi-thieu"]');
        if (tabElement) {
            tabElement.addEventListener('click', animateOnTabClick);
        }

        return () => {
            if (tabElement) {
                tabElement.removeEventListener('click', animateOnTabClick);
            }
        };
    }, []);

    return (
        <div className={cx('about-container')}>
            {/* Background pattern */}
            <div className={cx('bg-pattern')}></div>

            {/* Họa tiết bên trái */}
            <div className={cx('side-decorations-left')}>
                <div className={cx('side-decoration', 'left-circle-1')}></div>
                <div className={cx('side-decoration', 'left-circle-2')}></div>
                <div className={cx('side-decoration', 'left-circle-3')}></div>
                <div className={cx('side-decoration', 'left-square-1')}></div>
                <div className={cx('side-decoration', 'left-triangle-1')}></div>
                <div className={cx('side-decoration', 'left-line-1')}></div>
                <div className={cx('side-decoration', 'left-dots-1')}>
                    <div className={cx('dot')}></div>
                    <div className={cx('dot')}></div>
                    <div className={cx('dot')}></div>
                    <div className={cx('dot')}></div>
                </div>
                <div className={cx('side-decoration', 'left-star-1')}></div>
            </div>

            {/* Họa tiết bên phải */}
            <div className={cx('side-decorations-right')}>
                <div className={cx('side-decoration', 'right-circle-1')}></div>
                <div className={cx('side-decoration', 'right-circle-2')}></div>
                <div className={cx('side-decoration', 'right-circle-3')}></div>
                <div className={cx('side-decoration', 'right-square-1')}></div>
                <div className={cx('side-decoration', 'right-triangle-1')}></div>
                <div className={cx('side-decoration', 'right-line-1')}></div>
                <div className={cx('side-decoration', 'right-dots-1')}>
                    <div className={cx('dot')}></div>
                    <div className={cx('dot')}></div>
                    <div className={cx('dot')}></div>
                    <div className={cx('dot')}></div>
                </div>
                <div className={cx('side-decoration', 'right-diamond-1')}></div>
            </div>

            {/* Các hình trang trí - Thêm rất nhiều trang trí và không bị giới hạn */}
            <div className={cx('decoration', 'circle-1')}></div>
            <div className={cx('decoration', 'circle-2')}></div>
            <div className={cx('decoration', 'circle-3')}></div>
            <div className={cx('decoration', 'circle-4')}></div>
            <div className={cx('decoration', 'circle-5')}></div>
            <div className={cx('decoration', 'circle-6')}></div>
            <div className={cx('decoration', 'circle-7')}></div>
            <div className={cx('decoration', 'circle-8')}></div>
            <div className={cx('decoration', 'circle-9')}></div>
            <div className={cx('decoration', 'circle-10')}></div>
            <div className={cx('decoration', 'circle-11')}></div>
            <div className={cx('decoration', 'circle-12')}></div>
            <div className={cx('decoration', 'circle-13')}></div>
            <div className={cx('decoration', 'circle-14')}></div>
            <div className={cx('decoration', 'triangle')}></div>
            <div className={cx('decoration', 'triangle-2')}></div>
            <div className={cx('decoration', 'triangle-3')}></div>
            <div className={cx('decoration', 'triangle-4')}></div>
            <div className={cx('decoration', 'triangle-5')}></div>
            <div className={cx('decoration', 'triangle-6')}></div>
            <div className={cx('decoration', 'triangle-7')}></div>
            <div className={cx('decoration', 'triangle-8')}></div>
            <div className={cx('decoration', 'square')}></div>
            <div className={cx('decoration', 'square-2')}></div>
            <div className={cx('decoration', 'square-3')}></div>
            <div className={cx('decoration', 'square-4')}></div>
            <div className={cx('decoration', 'square-5')}></div>
            <div className={cx('decoration', 'square-6')}></div>
            <div className={cx('decoration', 'square-7')}></div>
            <div className={cx('decoration', 'square-8')}></div>
            <div className={cx('decoration', 'line-1')}></div>
            <div className={cx('decoration', 'line-2')}></div>
            <div className={cx('decoration', 'line-3')}></div>
            <div className={cx('decoration', 'line-4')}></div>
            <div className={cx('decoration', 'line-5')}></div>
            <div className={cx('decoration', 'line-6')}></div>
            <div className={cx('decoration', 'dot-group-1')}>
                <div className={cx('dot')}></div>
                <div className={cx('dot')}></div>
                <div className={cx('dot')}></div>
                <div className={cx('dot')}></div>
            </div>
            <div className={cx('decoration', 'dot-group-2')}>
                <div className={cx('dot')}></div>
                <div className={cx('dot')}></div>
                <div className={cx('dot')}></div>
                <div className={cx('dot')}></div>
                <div className={cx('dot')}></div>
            </div>
            <div className={cx('decoration', 'dot-group-3')}>
                <div className={cx('dot')}></div>
                <div className={cx('dot')}></div>
                <div className={cx('dot')}></div>
                <div className={cx('dot')}></div>
                <div className={cx('dot')}></div>
                <div className={cx('dot')}></div>
            </div>
            <div className={cx('decoration', 'dot-group-4')}>
                <div className={cx('dot')}></div>
                <div className={cx('dot')}></div>
                <div className={cx('dot')}></div>
                <div className={cx('dot')}></div>
                <div className={cx('dot')}></div>
            </div>
            <div className={cx('decoration', 'dot-group-5')}>
                <div className={cx('dot')}></div>
                <div className={cx('dot')}></div>
                <div className={cx('dot')}></div>
                <div className={cx('dot')}></div>
            </div>
            <div className={cx('decoration', 'zigzag-1')}></div>
            <div className={cx('decoration', 'zigzag-2')}></div>
            <div className={cx('decoration', 'zigzag-3')}></div>
            <div className={cx('decoration', 'zigzag-4')}></div>
            <div className={cx('decoration', 'zigzag-5')}></div>
            <div className={cx('decoration', 'wave-1')}></div>
            <div className={cx('decoration', 'wave-2')}></div>
            <div className={cx('decoration', 'wave-3')}></div>
            <div className={cx('decoration', 'wave-4')}></div>
            <div className={cx('decoration', 'cross-1')}></div>
            <div className={cx('decoration', 'cross-2')}></div>
            <div className={cx('decoration', 'cross-3')}></div>
            <div className={cx('decoration', 'star-1')}></div>
            <div className={cx('decoration', 'star-2')}></div>
            <div className={cx('decoration', 'star-3')}></div>
            <div className={cx('decoration', 'rectangle-1')}></div>
            <div className={cx('decoration', 'rectangle-2')}></div>
            <div className={cx('decoration', 'rectangle-3')}></div>
            <div className={cx('decoration', 'diamond-1')}></div>
            <div className={cx('decoration', 'diamond-2')}></div>
            <div className={cx('decoration', 'diamond-3')}></div>

            <div className={cx('about-content', { 'animate-content': isVisible })}>
                {/* Thông tin cá nhân */}
                <div className={cx('about-section', 'info-card', { animate: isVisible, 'delay-1': isVisible })}>
                    <div className={cx('section-header')}>
                        <UserOutlined className={cx('section-icon')} />
                        <h2>Thông tin cá nhân</h2>
                    </div>

                    <div className={cx('personal-info')}>
                        <div className={cx('info-row')}>
                            <div className={cx('info-item')}>
                                <span className={cx('info-label')}>Họ và tên:</span>
                                <span className={cx('info-value')}>Nguyễn Mạnh Phương</span>
                            </div>

                            <div className={cx('info-item')}>
                                <span className={cx('info-label')}>Vị trí:</span>
                                <span className={cx('info-value')}>Fullstack Developer</span>
                            </div>
                        </div>

                        <div className={cx('info-row')}>
                            <div className={cx('info-item')}>
                                <span className={cx('info-label')}>Quê quán:</span>
                                <span className={cx('info-value')}>Hưng Yên</span>
                            </div>

                            <div className={cx('info-item')}>
                                <span className={cx('info-label')}>Email:</span>
                                <span className={cx('info-value')}>manhphuong.dev@gmail.com</span>
                            </div>
                        </div>

                        <div className={cx('info-row')}>
                            <div className={cx('info-item')}>
                                <span className={cx('info-label')}>Github:</span>
                                <a
                                    href="https://github.com/Manh-Phuong"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={cx('info-link')}
                                >
                                    github.com/Manh-Phuong
                                </a>
                            </div>
                            {/* Thêm một info-item trống cho căn đều layout */}
                            {/* <div className={cx('info-item', 'invisible')}></div> */}
                            <div className={cx('info-item')}>
                                <span className={cx('info-label')}>Trình độ học vấn:</span>
                                <span className={cx('info-value')}>
                                    Cử nhân Khoa học Máy tính - Đại học Bách Khoa Hà Nội (2020-2024)
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Mục tiêu nghề nghiệp */}
                <div className={cx('about-section', 'goals-card', { animate: isVisible, 'delay-2': isVisible })}>
                    <div className={cx('section-header')}>
                        <AimOutlined className={cx('section-icon')} />
                        <h2>Mục tiêu nghề nghiệp</h2>
                    </div>

                    <div className={cx('career-goals')}>
                        <div className={cx('goal-item')}>
                            <h3>Mục tiêu ngắn hạn</h3>
                            <p>
                                Nâng cao kỹ năng lập trình phía backend, hiểu sâu hơn về kiến trúc hệ thống và các mô
                                hình triển khai hiệu quả. Phát triển khả năng tối ưu hóa hiệu suất và xử lý vấn đề bảo
                                mật trong các ứng dụng web. Nâng cao kỹ năng làm việc với các công nghệ container và
                                microservices.
                            </p>
                        </div>

                        <div className={cx('goal-item')}>
                            <h3>Mục tiêu dài hạn</h3>
                            <p>
                                Xây dựng nền tảng vững chắc để trở thành một lập trình viên toàn diện, có khả năng thiết
                                kế và triển khai các hệ thống đáng tin cậy. Phát triển kỹ năng lãnh đạo kỹ thuật và quản
                                lý dự án để có thể đảm nhận vai trò lãnh đạo trong tương lai. Hướng tới việc không ngừng
                                học hỏi và ứng dụng những công nghệ tiên tiến để giải quyết các bài toán phức tạp, mang
                                lại giá trị thực tiễn cho doanh nghiệp và người dùng.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Điểm mạnh */}
                <div className={cx('about-section', 'strengths-card', { animate: isVisible, 'delay-3': isVisible })}>
                    <div className={cx('section-header')}>
                        <TrophyOutlined className={cx('section-icon')} />
                        <h2>Điểm mạnh</h2>
                    </div>

                    <ul className={cx('strengths-list')}>
                        <li>
                            <div className={cx('strength-title')}>Chủ động trong công việc:</div>
                            <div className={cx('strength-desc')}>
                                Sẵn sàng đối mặt với thử thách mới và luôn tìm cách giải quyết vấn đề một cách chủ động.
                            </div>
                        </li>
                        <li>
                            <div className={cx('strength-title')}>Học hỏi liên tục:</div>
                            <div className={cx('strength-desc')}>
                                Luôn tìm hiểu và tiếp thu các kiến thức mới để nâng cao kỹ năng chuyên môn và cập nhật
                                xu hướng công nghệ.
                            </div>
                        </li>
                        <li>
                            <div className={cx('strength-title')}>Tư duy logic:</div>
                            <div className={cx('strength-desc')}>
                                Có khả năng phân tích vấn đề một cách có hệ thống và tìm ra giải pháp hiệu quả.
                            </div>
                        </li>
                        <li>
                            <div className={cx('strength-title')}>Kỹ năng làm việc nhóm:</div>
                            <div className={cx('strength-desc')}>
                                Giao tiếp tốt, biết lắng nghe và đóng góp ý kiến xây dựng trong các dự án nhóm.
                            </div>
                        </li>
                        <li>
                            <div className={cx('strength-title')}>Khả năng thích ứng:</div>
                            <div className={cx('strength-desc')}>
                                Nhanh chóng làm quen với công nghệ mới và môi trường làm việc khác nhau.
                            </div>
                        </li>
                    </ul>
                </div>

                {/* Sở thích cá nhân */}
                <div className={cx('about-section', 'hobbies-card', { animate: isVisible, 'delay-4': isVisible })}>
                    <div className={cx('section-header')}>
                        <HeartOutlined className={cx('section-icon')} />
                        <h2>Sở thích cá nhân</h2>
                    </div>

                    <p className={cx('hobbies')}>
                        Tôi thường xuyên <span className={cx('highlight')}>tìm hiểu các xu hướng công nghệ mới</span> để
                        cập nhật kiến thức và mở rộng tầm nhìn trong lĩnh vực công nghệ. Việc{' '}
                        <span className={cx('highlight')}>tham gia các diễn đàn và cộng đồng lập trình</span> giúp tôi
                        học hỏi từ những người có kinh nghiệm và chia sẻ kiến thức với những người mới bắt đầu. Tôi cũng
                        dành thời gian rảnh để <span className={cx('highlight')}>phát triển các dự án cá nhân</span>,
                        điều này không chỉ giúp tôi cải thiện kỹ năng lập trình mà còn là cơ hội để thử nghiệm các ý
                        tưởng mới. Ngoài công việc, tôi thích{' '}
                        <span className={cx('highlight')}>khám phá các công cụ và nền tảng công nghệ mới</span>, từ đó
                        áp dụng chúng vào thực tế để tối ưu hóa quy trình làm việc và nâng cao hiệu suất.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default About;
